<!--
 * @Description: 
 * @Author: Lizhiliang
 * @Date: 2022-12-26 16:25:29
 * @LastEditTime: 2023-01-12 11:55:36
 * @LastEditors: lizhiliang
 * @Usage: 
-->
<template>
    <div class="face-detail-view">
        <!-- 用户组 -->
        <div class="face-group">
            <!-- 搜索行 -->
            <div class="search-line">
                <div class="face-operation">
                    <ux-button class="add-button" type="primary" icon="ux_icon_plus" @click="addUserGroup">{{ $t('HT.add.group')}}</ux-button>
                </div>
            </div>
            <!-- 用户组 -->
            <div class="collapse-content">
                <ux-table
                  :data="groupListArray"
                  :show-page="false"
                  :columns="columns"
                  :emptyText="$t('HT.nodata')">
                </ux-table>
            </div>
        </div>
        <!-- 对应用户 -->
        <el-drawer
            :title="$t('HT.router.userList')"
            :append-to-body="true"
            :visible.sync="showGroupUser"
            :modal="false"
            custom-class="group-userlist"
            size="460px"
            @closed="closeUser">
            <div class="face-group-user">
              <div class="search-line">
                  <div class="face-operation">
                      <ux-button class="add-button" type="primary" icon="ux_icon_plus" @click="addUser">{{ $t('HT.add.user') }}</ux-button>
                  </div>
              </div>
              <!-- 用户 -->
              <div class="collapse-content">
                  <ux-table
                    ref="table"
                    v-loadmore="loadMoreUser"
                    :data="groupUserList"
                    :show-page="false"
                    :columns="columnsUser"
                    :emptyText="$t('HT.nodata')">
                  </ux-table>
                  <p v-show="showMoreText" class="load-more">{{ loadMore ? $t('HT.load.more') : this.$t('HT.no.more') }}</p>
              </div>
          </div>
        </el-drawer>
        <!-- 对应用户人脸列表 -->
        <el-drawer
            :title="drawerTitle"
            :append-to-body="true"
            :visible.sync="innerDrawer"
            :modal="false"
            custom-class="user-facelist"
            size="680px">
            <div class="face-add">
                <ux-button class="add-button" type="primary" icon="ux_icon_plus" :disabled="faceLists.length >= 20" @click="addUserFaceForm">{{ $t('HT.add.face') }}</ux-button>
                <span class="add-tip">{{ $t('HT.add.most.num', {max: 20}) }}</span>
            </div>
            <div class="face-list x-scrollbar-show">
                <div class="face-list-item" v-for="(img, index) in faceLists" :key="index">
                    <ux-image
                        class="face-img"
                        fit="cover"
                        :src="img.face_url || require('@/assets/images/web/img_placeholder2.png')"
                        :preview-src-list="srcList"
                    ></ux-image>
                    <p class="face-time">{{ $t('HT.create.by') + img.ctime }}</p>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import addGroup from './addGroup';
import addGroupUser from './addGroupUser';
import addUserFace from './addUserFace';
import delRulePop from './delRulePop';
import Cookies from 'js-cookie'; // cookie插件
import OSS from 'ali-oss';

export default {
  props: {
    appdata: {
      type: Object,
      default: () => {
        return {};
      }
    },
    group: {
      type: Array,
      default: () => {
        return [];
      }
    },
    groupArr: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      groupList: JSON.parse(JSON.stringify(this.group)),
      groupListArray: JSON.parse(JSON.stringify(this.groupArr)),
      columns: [
        {
          label: this.$t('HT.router.userListGroup'),
          prop: 'groupId',
          tooltip: true,
          render: (h, params) => {
            return h('span', {
              class: ['x-table-blue-btn'],
              on: {
                click: () => {
                  this.getGroupUserList(params.groupId);
                }
              }
            }, params.groupId);
          }
        },
        {
          label: this.$t('HT.operation'),
          render: (h, params) => {
            return h(delRulePop, {
              props: {
                width: '240px',
                title: this.$t('HT.delete.group.message'),
                text: this.$t('HT.delete'),
                placement: 'bottom'
              },
              on: {
                'on-confirm': () => {
                  this.deleteGroup(params.groupId);
                }
              }
            });
          }
        }
      ],
      showGroupUser: false,
      selectGroup: '',
      selectUser: '',
      groupUserList: [],
      columnsUser: [
        {
          label: this.$t('HT.user.id'),
          prop: 'userId',
          tooltip: true,
          render: (h, params) => {
            return h('span', {
              class: ['x-table-blue-btn'],
              on: {
                click: () => {
                  this.drawerTitle = params.userId;
                  this.getUserFaceList(params.userId);
                  // this.$router.push({ path: `/applyInfo/${params.id}`});
                }
              }
            }, params.userId);
          }
        },
        {
          label: this.$t('HT.operation'),
          render: (h, params) => {
            return h(delRulePop, {
              props: {
                width: '240px',
                title: this.$t('HT.confirm.delete.user.message'),
                text: this.$t('HT.delete'),
                placement: 'bottom'
              },
              on: {
                'on-confirm': () => {
                  this.deleteUser(params.userId);
                }
              }
            });
          }
        }
      ],
      innerDrawer: false,
      drawerTitle: '',
      faceLists: [],
      loadMore: true,
      srcList: [],
      showMoreText: false
    };
  },
  watch: {
    groupArr: {
      handler(newVal) {
        // console.log('newVal1', newVal);
        this.groupListArray = JSON.parse(JSON.stringify(newVal));
      }
    },
    group: {
      handler(newVal) {
        // console.log('newVal2', newVal);
        this.groupList = JSON.parse(JSON.stringify(newVal));
      }
    }
  },
  created() {
    // this.getGroupList();
  },
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector('.el-table__body-wrapper');
        // console.log('selectWrap', selectWrap);
        selectWrap.addEventListener('scroll', function () {
          let sign = 0;
          const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
          // console.log('Math.ceil(scrollDistance)', Math.ceil(scrollDistance), binding);
          binding.value(Math.ceil(scrollDistance) <= sign);
        });
      }
    }
  },
  methods: {
    // 获取用户组
    getGroupList() {
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        ver: 1
      };
      this.$api.faceRecognition.getFaceGroupList(params)
        .then(res => {
          if (res.code == 10000) {
            this.groupList = res.data.group_id_list;
            this.groupListArray = [];
            res.data.group_id_list.forEach((item) => {
              this.groupListArray.push({ groupId: item });
            });
          }
        });
    },
    // 获取对应用户
    getGroupUserList(groupId, loadBool = false) {
      const lang = Cookies.get('locale') === 'zh' ? 'zh_CN' : 'en_US';
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        length: 20,
        start: loadBool ? this.groupUserList.length : 0,
        groupId,
        ver: 1,
        lang
      };
      this.$api.faceRecognition.getFaceUser(params)
        .then(res => {
          if (res.code == 10000) {
            this.groupUserList = loadBool ? this.groupUserList : [];
            res.data.user_id_list.forEach((user) => {
              this.groupUserList.push({ userId: user });
            });
            this.loadMore = res.data.user_id_list.length >= 20;
            this.selectGroup = groupId;
            this.showGroupUser = true;
          }
        });
    },
    // 下拉加载更多用户
    loadMoreUser(isRequest) {
      // console.log('loadMoreUser', isRequest, this.showMoreText);
      this.showMoreText = isRequest;
      isRequest && this.loadMore && this.getGroupUserList(this.selectGroup, true);
    },
    // 上传图片
    uploadImage(imagelist) {
      return new Promise((resolve) => {
        this.$api.faceRecognition.getOssToken({bucket: 'BUCKET_FACE'})
          .then(res => {
            if (res.code == 10000) {
              const promises = [];
              // console.log('imagelist', imagelist);
              imagelist.forEach(item => {
                const p = this.ossClient(res.data, item);
                promises.push(p);
              });
              Promise.all(promises).then((res) => {
                resolve(res);
              });
            }
          });
      });
    },
    getOssToken() {
      const _this = this;
      return new Promise(function(resolve) {
        _this.$api.faceRecognition.getOssToken({bucket: 'BUCKET_FACE'})
          .then(res => {
            if (res.code == 10000) {
              resolve(res.data);
            }
          });
      });
    },
    // 上传至阿里云
    ossClient(params, file) {
      return new Promise((resolve) => {
        const _this = this;
        // 实例化OSS Client。
        const client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
          contentType: '',
          region: params.region,
          // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
          accessKeyId: params.access_key_id,
          accessKeySecret: params.access_key_secret,
          // 从STS服务获取的安全令牌（SecurityToken）。
          stsToken: params.sts_token,
          refreshSTSToken: async () => {
          // 向您搭建的STS服务获取临时访问凭证。
            const info = await _this.getOssToken();
            // console.log('info', info);
            return {
              accessKeyId: info.access_key_id,
              accessKeySecret: info.access_key_secret,
              stsToken: info.sts_token,
            };
          },
          // 刷新临时访问凭证的时间间隔，单位为毫秒。
          refreshSTSTokenInterval: 3600,
          // 填写Bucket名称。
          bucket: params.bucket,
        });
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        let fileName = file.name;
        fileName = fileName.substring(0, file.name.lastIndexOf('.'));
        fileName = `face_${fileName}_${new Date().getTime()}.jpg`;
        client
          .put(fileName, file.raw, {
            headers: {
              'Content-Type': 'image/jpg'
            }
          })
          .then(function (r1) {
            console.log('put success: %j', r1);
            return client.signatureUrl(fileName, { expires: 60 * 5});
          })
          .then(function (r2) {
            // console.log('get success: %j', r2);
            resolve(r2);
          })
          .catch(function (err) {
            console.error('error: %j', err);
          });
      });
    },
    /**
     * 添加用户组
     */
    addUserGroup() {
      this.$modal.show({
        title: this.$t('HT.add.user.group'),
        content: (h) => {
          return h(addGroup);
        },
        confirm: (data) => {
          this.apiAddGroup(data);
        }
      });
    },
    apiAddGroup(data) {
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        ver: 1
      };
      this.$api.faceRecognition.addGroup(params, data)
        .then(res => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.add.success'));
            this.getGroupList();
          }
        });
    },
    /**
     * 删除用户组
    */
    deleteGroup(groupId) {
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        ver: 1
      };
      this.$api.faceRecognition.deleteGroup(params, {group_id: groupId})
        .then(res => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            this.getGroupList();
          }
        });
    },
    /**
     * 新增用户
    */
    addUser() {
      this.$modal.show({
        title: this.$t('HT.add.user'),
        content: (h) => {
          return h(addGroupUser);
        },
        confirm: (data) => {
          this.$uxLoading.show();
          this.uploadImage(data.imagelist).then(res => {
            data.image = res[0];
            this.apiAddGroupUser(data);
          });
        }
      });
    },
    apiAddGroupUser(data) {
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        ver: 1
      };
      this.$api.faceRecognition.addGroupUser(params, {
        group_id: this.selectGroup,
        image: data.image,
        image_type: data.image_type,
        user_id: data.user_id
      }).then(res => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.add.success'));
          this.getGroupUserList(this.selectGroup);
        } else {
          this.$uxMessage.error(res.sub_msg);
        }
      })
        .finally(() => {
          this.$uxLoading.hide();
        });
    },
    /**
         * 删除用户
        */
    deleteUser(userId) {
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        ver: 1
      };
      this.$api.faceRecognition.deleteGroupUser(params, {group_id: this.selectGroup, user_id: userId})
        .then(res => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            this.getGroupUserList(this.selectGroup);
          }
        });
    },
    closeUser() {
      this.groupUserList = [];
      this.loadMore = true;
    },
    /**
         * 获取用户人脸列表
        */
    getUserFaceList(userId) {
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        groupId: this.selectGroup,
        userId,
        ver: 1
      };
      this.selectUser = userId;
      this.$api.faceRecognition.getUserFace(params).then(res => {
        if (res.code == 10000) {
          this.faceLists = res.data.face_list;
          this.srcList = res.data.face_list.map(item => {
            return item.face_url;
          });
          this.innerDrawer = true;
        }
      });
    },
    /**
         * 新增用户人脸
        */
    addUserFaceForm() {
      this.$modal.show({
        title: this.$t('HT.add.face'),
        modalClass: 'add-face-modal',
        content: (h) => {
          return h(addUserFace);
        },
        confirm: (data) => {
          this.$uxLoading.show();
          this.uploadImage(data.imagelist).then(res => {
            data.image = res[0];
            this.apiAddUserFace(data);
          });
        }
      });
    },
    apiAddUserFace(data) {
      const params = {
        appKey: this.appdata.app_key,
        appSecret: this.appdata.app_secret,
        ver: 1
      };
      this.$api.faceRecognition.addUserFace(params, {
        group_id: this.selectGroup,
        user_id: this.selectUser,
        image: data.image,
        image_type: data.image_type
      })
        .then(res => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
            this.getUserFaceList(this.selectUser);
          } else {
            this.$uxMessage.error(res.sub_msg);
          }
        })
        .finally(() => {
          this.$uxLoading.hide();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.face-detail-view {
    height: 100%;
    .search-line {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: space-between;
    }
    .face-operation {
        display: flex;
        align-items: center;
        .page-count {
            margin-left: 16px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8690AA;
            line-height: 20px;
        }
    }
}
.face-group-user,.face-group {
  height: 100%;
  .collapse-content {
      margin-top: 32px;
      height: calc(100% - 146px);
      .load-more {
        text-align: center;
        padding: 44px 0 24px 0;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8690AA;
        line-height: 20px;
      }
  }
}
.user-facelist {
    .face-add {
        margin-bottom: 17px;
        .add-tip {
            margin-left: 16px;
        }
    }
    .face-list {
        height: 100%;
        padding-bottom: 24px;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        align-content: flex-start;
        .face-list-item {
            // margin: 0 20px 20px 0;
            width: 33.33%;
            margin-bottom: 20px;
        }
        .face-img {
            width: 200px;
            height: 200px;
            border-radius: 10px;
        }
        .face-time {
            margin-top: 10px;
        }
    }
}

.el-drawer__wrapper {
  z-index: 1000 !important;
}

::v-deep .group-userlist {
    padding: 32px 20px 24px;
    right: 460px;
    .el-drawer__header {
        border-bottom: 1px solid #E8ECF2;
        padding: 0 0 13px 0;
        margin-bottom: 20px;
        span {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #161E28;
            line-height: 26px;
        }
    }
    .el-drawer__body {
      height: calc(100% - 42px);
    }
}

::v-deep .user-facelist {
    padding: 32px 0px 0px 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8690AA;
    line-height: 20px;
    right: 920px;
    padding-bottom: 120px;
    .el-drawer__header {
        border-bottom: 1px solid #E8ECF2;
        padding: 0 0 13px 0;
        margin:0 20px 20px 0;
        span {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #161E28;
            line-height: 26px;
        }
    }
    .el-drawer__body {
      height: 100%;
    }
}

</style>